import { Controller } from "@hotwired/stimulus"

const HEADER_ALERT_CLASSES = ["bg-rose-100"]
const HEADER_WARNING_CLASSES = ["bg-amber-100"]
const HEADER_EMPHASIS_CLASSES = ["rounded-t-md"]
// Include hover so global `a { text-sky-* }` base styles cannot recolor linked titles.
const TITLE_ALERT_CLASSES = ["text-rose-800", "hover:text-rose-900"]
const TITLE_WARNING_CLASSES = ["text-amber-900", "hover:text-amber-950"]

// Lights the card header/title when status-line content marks an alert.
// Prefer [data-hq-data-card-alert] over icon classes — Font Awesome replaces <i> with <svg>.
export default class extends Controller {
  static targets = ["header", "title"]

  connect() {
    this.element.addEventListener("turbo:frame-load", this.refresh)
    this.element.addEventListener("turbo:frame-render", this.refresh)
    this.refresh()
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this.refresh)
    this.element.removeEventListener("turbo:frame-render", this.refresh)
  }

  refresh = () => {
    const hasAlert = Boolean(this.element.querySelector("[data-hq-data-card-alert]"))
    const showWarning =
      this.element.getAttribute("data-hq--data--card-alert-warning-value") === "true" && !hasAlert

    if (this.hasHeaderTarget) {
      HEADER_ALERT_CLASSES.forEach((className) => {
        this.headerTarget.classList.toggle(className, hasAlert)
      })
      HEADER_WARNING_CLASSES.forEach((className) => {
        this.headerTarget.classList.toggle(className, showWarning)
      })
      HEADER_EMPHASIS_CLASSES.forEach((className) => {
        this.headerTarget.classList.toggle(className, hasAlert || showWarning)
      })
    }

    if (this.hasTitleTarget) {
      TITLE_ALERT_CLASSES.forEach((className) => {
        this.titleTarget.classList.toggle(className, hasAlert)
      })
      TITLE_WARNING_CLASSES.forEach((className) => {
        this.titleTarget.classList.toggle(className, showWarning)
      })
    }
  }
}
